import { inject, Injectable } from '@angular/core';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs';
import { CreateSupplierProvider } from '@vdms-hq/users-core';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from '@vdms-hq/toast';
import { SuppliersCreateEditDialogComponent } from '../../suppliers-editor/suppliers-create-edit-dialog/suppliers-create-edit-dialog.component';
import { SuppliersListOption } from '@vdms-hq/shared';
import { SupplierService } from '@vdms-hq/api-contract';

@Injectable({
  providedIn: 'root',
})
export class SupplierActions implements CreateSupplierProvider {
  private matDialog = inject(MatDialog);
  private toastService = inject(ToastService);
  private supplierService = inject(SupplierService);

  #popToast = {
    CREATE_PROCESSING: () =>
      this.toastService.processing({
        id: 'create_supplier',
        message: 'notifications.suppliers.create.processing',
      }),
    CREATE_SUCCESS: () =>
      this.toastService.success({
        id: 'create_supplier',
        message: 'notifications.suppliers.create.success',
      }),
    CREATE_FAILURE: (reason = 'Not specified') =>
      this.toastService.error({
        id: 'create_supplier',
        message: 'notifications.suppliers.create.failure',
        interpolatedParams: { reason },
      }),
  };

  createSupplier(label: string) {
    const dialogRef = this.matDialog.open(SuppliersCreateEditDialogComponent, {
      data: { edit: false, label },
    });

    return dialogRef.afterClosed().pipe(
      take(1),
      filter((supplier: SuppliersListOption) => !!supplier),
      switchMap((supplier: SuppliersListOption) => {
        this.#popToast.CREATE_PROCESSING();

        return this.supplierService
          .postSupplier({
            ...supplier,
            groups: supplier.groups?.map(({ uuid }) => uuid),
            users: supplier.users?.map(({ uuid }) => uuid),
          })
          .pipe(
            map((data) => {
              return data ?? null;
            }),
          );
      }),
      tap(() => {
        this.#popToast.CREATE_SUCCESS();
      }),
      catchError(() => {
        this.#popToast.CREATE_FAILURE();

        return [false as const];
      }),
    );
  }
}
